import { Component, Vue } from 'vue-property-decorator'
import { isEmpty } from 'lodash'

@Component
export default class Router extends Vue {
  goToPreviousRoute() {
    this.$router.go(-1)
  }
}
